import styled from 'styled-components';

export const Container = styled.div`
    padding: 0 20px;
    background-color: ${p => p.theme.c.snow};
    height: 626px;
    box-shadow: 0 0 8px 0 ${p => p.theme.c.blackShadow1};
    margin-top: 29px;
    overflow-y: auto;
    padding-top: 20px;
`;